<template>
  <CCard>
    <CCardHeader> Registrations </CCardHeader>
    <CCardBody>
      <div class="row my-2 mx-0 justify-content-between">
        <div class="col-sm-6 form-inline p-0">
          <label class="mr-2">Filter:</label>
          <input
            type="text"
            placeholder="type email..."
            class="form-control"
            v-model="filter"
          />
        </div>
        <div class="col-sm-3 form-inline p-0 justify-content-end">
            <CSelect label="Status: " :value.sync="filterStatus" :options="['','N/a','approved','downloaded','refused']"></CSelect>
        </div>
      </div>
      <div class="table-responsive-sm">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="center">Created at</th>
              <th>Email</th>
              <th>Full Name</th>
              <th class="right">Request IPs</th>
              <th class="center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(reg, index) in registrations"
              :key="index"
              @click="showModal(reg,index)"
              style="cursor: pointer"
            >
              <td class="center">{{ reg.regdate | formatDate }}</td>
              <td class="left">
                {{ reg.email }}
                <span :title="reg.verified_date | addVerifiedDate($root)">
                <CBadge :color="getBadge(reg.email_verified)">{{
                  reg.email_verified | verifiedText
                }}</CBadge></span>
              </td>
              <td class="left">{{ reg.fname }}</td>
              <td class="right">{{ reg.ips | toIPString}}</td>
              <td class="right">
                <span :title="reg | addStatusDate($root)">
                <CBadge :color="getStatusBadge(reg.status)">{{
                  reg.status
                }}</CBadge></span>
              </td>
            </tr>
            <tr v-if="loading">
              <td class="text-center" colspan="7"><CSpinner color="info" /></td>
            </tr>
            <tr v-if="!loading && registrations.length === 0">
              <td class="text-center" colspan="7">No record found.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <CPagination
        :active-page.sync="currentPage"
        :pages.sync="pages"
        align="center"
        responsive
      />
      <CModal title="Registration" :show.sync="regModal">
        <CForm ref="itemForm">
          <CInput
            label="Created Date"
            :value="selectItem.regdate | formatDate"
            horizontal
            plaintext
          />
          <div role="group" class="form-group form-row">
            <label class="col-form-label col-sm-3"> Email</label>
            <div class="col-sm-9">
              <!---->
              <span class="form-control-plaintext"
                >{{ selectItem.email }}
                <span :title="selectItem.verified_date | addVerifiedDate(this)"
                  ><CBadge :color="getBadge(selectItem.email_verified)">{{
                    selectItem.email_verified | verifiedText
                  }}</CBadge></span
                ></span
              >
            </div>
          </div>
          <CInput
            label="Verified Date"
            :value="selectItem.verified_date | addVerifiedDate(this)"
            horizontal
            plaintext
          />
          <CInput
            label="Full Name"
            :value="selectItem.fname"
            horizontal
            plaintext
          />
          <CInput
            label="Organization"
            :value="selectItem.orgname"
            horizontal
            plaintext
          />
          <CInput
            label="Job Title"
            :value="selectItem.jobtitle"
            horizontal
            plaintext
          />
          <div role="group" class="form-group form-row">
            <label class="col-form-label col-sm-3">Request IPs</label>
            <div class="col-sm-9">
              <!---->
              <span class="form-control-plaintext"
                v-html="$options.filters.downloadStatus(selectItem.ips,this)"></span
              >
              <!--
              <template v-for="(ip, index) in selectItem.ips">
                 <span class="form-control-plaintext"
                v-html="$options.filters.ipDownloadStatus(ip,this)"></span>
              </template>
              -->
            </div>
          </div>
          <CInput
            label="Approver"
            :value="selectItem.approver"
            horizontal
            plaintext
          />
          <div role="group" class="form-group form-row">
            <label class="col-form-label col-sm-3"> Status</label>
            <div class="col-sm-9">
              <!---->
              <span class="form-control-plaintext" :title="selectItem | addStatusDate(this)"
                ><CBadge :color="getStatusBadge(selectItem.status)">{{
                  selectItem.status
                }}</CBadge></span
              >
            </div>
          </div>
          <CTextarea
                label="Reason"
                placeholder="Content..."
                horizontal
                rows="2"
                v-model="selectItem.reason"
                :disabled="selectItem.status === 'approved'"
              />
        </CForm>
        <template #footer>
          <CButton
             @click="approve('force')"
            color="secondary"
            :disabled="
              selectItem.email_verified
            "
            >Force verify and approve</CButton
          >
          <CButton
            @click="approve('refused')"
            color="danger"
            :disabled="
              selectItem.email_verified ? (selectItem.status === 'refused' || selectItem.status === 'approved' || selectItem.status === 'downloaded' || formSubmitted) : true
            "
            >Refuse</CButton
          >
          <CButton
            @click="approve('approved')"
            color="success"
            :disabled="selectItem.email_verified ? (selectItem.status === 'approved' || selectItem.status === 'downloaded' || formSubmitted) : true"
            >Approve</CButton
          >
        </template>
      </CModal>
    </CCardBody>
  </CCard>
</template>
<style scoped>
.form-group {
  margin-bottom: unset;
}
</style>
<script>
import firebase from "firebase/app";
import firestore from "firebase/firestore";

export default {
  name: "Registrations",
  data: () => {
    return {
      regModal: false,
      filter: "",
      filterStatus: '',
      loading: true,
      registrations: [],
      currentPage: 1,
      pages: 0,
      perPage: 10,
      lastVisible: "",
      firstVisible: "",
      selectItem: "",
      selectIndex: -1,
      formSubmitted : false
    };
  },
  filters: {
    toIPString: function(value){
      if(value && Array.isArray(value)){
        return value.join();
      }else{
        return value;
      }
    },
    ipDownloadStatus: function(value,obj){
      if(value && obj){
        return value + ` <i class="cil-cloud-download" title="${ obj.$options.filters.formatDate(obj.selectItem['ip_'+ value + '_download'])}"></i>`;
      }else{
        return '';
      }
    },
    downloadStatus: function(value,obj){
      let status = [];
      if(value && obj){
        if(!Array.isArray(value)){
          value = [value];
        }
        for(let i = 0; i< value.length; i++){
          let ip = value[i];
          if(obj.selectItem['ip_'+ ip + '_download']){
            status.push(ip + ` <i class="cil-cloud-download" title="${ obj.$options.filters.formatDate(obj.selectItem['ip_'+ ip + '_download'])}"></i>`);
            //obj.$options.filters.formatDate(obj.selectItem['ip_'+ ip + '_download']))
          }else{
            status.push(ip)
          }
        }
      }
      return status.join();
    },
    verifiedText: function (value) {
      if (value) return "verified";
      else return "";
    },
    addStatusDate: function (reg, obj) {
      if (reg.status === 'approved' || reg.status ==='refused') {
        return obj.$options.filters.formatDate(reg.approval_date) + (reg.approver?(' ' + reg.approver):'');
      } else if (reg.status === 'downloaded') {
        return obj.$options.filters.formatDate(reg.download_date);
      } else{
        return '';
      }
    },
    addVerifiedDate: function (value, obj) {
      if (value) {
        return obj.$options.filters.formatDate(value);
      } else {
        return value;
      }
    },
  },
  methods: {
    getBadge: function (status) {
      return status === true
        ? "success"
        : status === false
        ? "danger"
        : "primary";
    },
    getStatusBadge: function (status) {
      return status === "approved"
        ? "success"
        : status === "refused"
        ? "danger"
        : "primary";
    },
    approve: function (action) {
      var self = this;
      if(confirm('Are you sure?')){
        if((action === 'refused' || action === 'force') &&  !self.selectItem.reason){
          let input = self.$refs.itemForm.querySelector('textarea');
          input.setCustomValidity('Reason is required');
          input.reportValidity();
          return;
        }
        self.formSubmitted = true;
        self.$http
          .post("/v1/api/approve", {
            email: self.selectItem.email,
            action: action,
            reason: self.selectItem.reason,
            approver: self.$store.state.user.email.split("@")[0]
          })
          .then(function (response) {
            self.selectItem = response.data;
            self.registrations[self.selectIndex] = response.data;
            self.regModal = false;
          })
          .catch(function (error) {
            self.showError = true;
            console.log(error);
          })
          .then(function () {
            // always executed
            self.formSubmitted = false;
          });
      }
    },
    search: async function (action) {
      this.loading = true;
      this.registrations = [];
      let regs = [];
      var db = firebase.firestore();
      let regRefs = db.collection("registration");
      if(this.filterStatus !== ''){
        if(this.filterStatus === 'N/a'){
          regRefs = regRefs.where("status", "==", '');
        }else{
          regRefs = regRefs.where("status", "==", this.filterStatus);
        }
      }
      if (this.filter !== "") {
        regRefs = regRefs.where("email", ">=", this.filter);
        regRefs = regRefs.where("email", "<=", this.filter + "\uf8ff");
      } else {
        regRefs = regRefs.orderBy("regdate", "desc");
      }
      let allCol = await regRefs.get();
      this.pages = Math.ceil(allCol.size / this.perPage);
      if(this.pages === 0) this.pages = 1;
      if (action === "next") {
        regRefs = regRefs.startAfter(this.lastVisible);
        regRefs = regRefs.limit(this.perPage);
      } else if (action === "prev") {
        regRefs = regRefs.endBefore(this.firstVisible);
        regRefs = regRefs.limitToLast(this.perPage);
      } else {
        regRefs = regRefs.limit(this.perPage);
      }
      let regCol = await regRefs.get();
      this.lastVisible = regCol.docs[regCol.docs.length - 1];
      this.firstVisible = regCol.docs[0];
      regCol.forEach((doc) => regs.push(doc.data()));
      this.loading = false;
      this.registrations = regs;
    },
    showModal: function (value, index) {
      this.selectItem = value;
      this.selectIndex = index;
      this.regModal = true;
      console.log(this.selectItem)
    },
  },
  created() {
    this.search = _.debounce(this.search, 500);
  },
  watch: {
    filter: function (value) {
      (this.currentPage = 1), (this.lastVisible = "");
      this.firstVisible = "";
      this.search();
    },
    filterStatus: function(value) {
      (this.currentPage = 1), (this.lastVisible = "");
      this.firstVisible = "";
      this.search();
    },
    currentPage: function (value, oldValue) {
      if (value === oldValue + 1) this.search("next");
      else if (value === oldValue - 1) this.search("prev");
    },
  },
  mounted: function () {
    this.search();
  },
};
</script>
